import React from 'react';
import { downloadWorkStandardAction } from '../../../../../../services/request';
import { WorkStandardsGeneric } from './generics/WorkStandardsGeneric';

export const WorkStandards = () => (
  <WorkStandardsGeneric
    downloadDocumentAction={downloadWorkStandardAction}
    serializerFieldName="work_standard_documents"
    title="Standardy Pracy" />
);
